import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import TitleComponent from '#app/Component/TitleComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/Shop/Sale/SelectClient/hooks/useClientList';

type Props = {
  handleSearch: (data: Filters) => void;
};

const Search: React.FC<Props> = ({ handleSearch }) => {
  const classes = useStyles();

  const [formSearch, setFormSearch] = useState<Form>({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
    },
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
    },
    firstname: {
      name: 'firstname',
      label: 'Prénom',
      textHelper: 'Rechercher par prénom.',
      type: 'text',
    },
    lastname: {
      name: 'lastname',
      label: 'Nom',
      textHelper: 'Rechercher par nom.',
      type: 'text',
    },
    zipCode: {
      name: 'zipCode',
      label: 'Code postal',
      textHelper: 'Rechercher par code postal.',
      type: 'text',
    },
    phone: {
      name: 'phone',
      label: 'Téléphone',
      textHelper: 'Rechercher par téléphone.',
      type: 'text',
    },
  });

  const handlerForm = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerForm.start();
  }, []);

  const getData = (): Filters => {
    const data = handlerForm.getData();
    return {
      number: data.number,
      email: data.email,
      firstname: data.firstname,
      lastname: data.lastname,
      zipCode: data.zipCode,
      phone: data.phone,
    };
  };

  return (
    <ShadowBoxComponent className={classes.container}>
      <TitleComponent title="Rechercher un client" />
      <Grid container>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="number" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="email" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="firstname" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="lastname" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="zipCode" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="phone" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <ButtonComponent className={classes.button} label="Rechercher" onClick={() => handleSearch(getData())} />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 25,
    marginBottom: 10,
  },
  button: {
    margin: '6px !important',
  },
});

export default Search;
